module.exports = __webpack_public_path__ + "static/media/lady-background.d7e273fd.jpg";